import { handleHideModal, handleInputChange } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { handleSubmitEditPerson } from 'components/views/InvestorTeam/_helpers/investorTeam.events';
import { Col, Row } from 'react-bootstrap';
import { $form, $view } from 'signals/global.signals';

const InvestorEditPersonModal = () => (
  <SimpleModal
    show={$view.value.activeModal === 'edit-person'}
    onHide={handleHideModal}
    enforceFocus={false}
    title="Edit Person"
    primaryButtonText="Save"
    onPrimaryClick={handleSubmitEditPerson}
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    isLoading={$view.value.isModalLoading}
  >
    <Row>
      <Col>
        <UniversalInput
          name="firstName"
          label="First Name"
          value={$form.value.firstName}
          className="mb-16"
        />
        <UniversalInput
          name="lastName"
          label="Last Name"
          value={$form.value.lastName}
          className="mb-16"
        />
        <UniversalInput
          name="email"
          label="Email"
          type="email"
          value={$form.value.email}
          className="mb-16"
        />
        <UniversalInput
          type="select"
          name="roles"
          label="Roles"
          value={$view.value.roleOptions?.filter(option => $form.value.roles?.includes(option.value))}
          options={$view.value.roleOptions}
          onChange={(selectedOptions) => {
            const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
            handleInputChange({ name: 'roles', value: selectedValues });
          }}
          isMulti
        />
        <UniversalInput
          type="select"
          name="teams"
          label="Teams"
          value={$view.value.teamOptions?.filter(option => $form.value.teams?.includes(option.value))}
          options={$view.value.teamOptions}
          onChange={(selectedOptions) => {
            const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
            handleInputChange({ name: 'teams', value: selectedValues });
          }}
          isMulti
        />
      </Col>
    </Row>
  </SimpleModal>
);

export default InvestorEditPersonModal;
